var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourism(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 17.4374L9.125 16.9583L3.375 19.8333V7.37494L9.125 4.49994L14.875 7.37494L20.625 4.49994V11.2083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 4.49994V16.9583",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 7.37494V11.2083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 21.75L20.9604 18.6028C21.1573 18.4118 21.3139 18.1832 21.421 17.9306C21.5281 17.6781 21.5835 17.4066 21.5839 17.1323C21.5844 16.858 21.5299 16.5863 21.4236 16.3334C21.3173 16.0805 21.1615 15.8514 20.9652 15.6598C20.5648 15.2681 20.0272 15.0484 19.4671 15.0473C18.9069 15.0462 18.3685 15.2639 17.9666 15.654L17.7519 15.8648L17.5382 15.654C17.1378 15.2627 16.6004 15.0431 16.0406 15.042C15.4807 15.0409 14.9425 15.2584 14.5406 15.6483C14.3436 15.8392 14.1869 16.0677 14.0798 16.3203C13.9726 16.5728 13.9171 16.8442 13.9166 17.1186C13.916 17.3929 13.9705 17.6645 14.0766 17.9175C14.1828 18.1704 14.3386 18.3996 14.5348 18.5913L17.75 21.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourism);
export default __webpack_public_path__ + "static/media/tourism.738ada07.svg";
export { ForwardRef as ReactComponent };